export default (state, action) => {
    switch(action.type) {
        case "ADD_MOVIE_TO_WATCHLIST":
            return {
                ...state, 
                movieWatchlist: [action.payload, ...state.movieWatchlist],
            };
        case "REMOVE_MOVIE_FROM_WATCHLIST":
            return {
                ...state,
                movieWatchlist: state.movieWatchlist.filter(
                    (movie) => movie.id !== action.payload
                )
            };
        case "ADD_MOVIE_TO_DONE":
            return {
                ...state,
                movieWatched: [action.payload, ...state.movieWatched],
            }
        case "REMOVE_MOVIE_FROM_DONE":
            return {
                ...state,
                movieWatched: state.movieWatched.filter((movie) => movie.id !== action.payload)
            };
        case "ADD_SERIE_TO_WATCHLIST":
            return {
                ...state, 
                serieWatchlist: [action.payload, ...state.serieWatchlist],
            };
        case "REMOVE_SERIE_FROM_WATCHLIST":
            return {
                ...state,
                serieWatchlist: state.serieWatchlist.filter(
                    (serie) => serie.id !== action.payload
                )
            };
        case "ADD_SERIE_TO_DONE":
            return {
                ...state,
                serieWatched: [action.payload, ...state.serieWatched],
            };
        case "REMOVE_SERIE_FROM_DONE":
                return {
                    ...state,
                    serieWatched: state.serieWatched.filter((serie) => serie.id !== action.payload)
            };
        case "ADD_BOOK_TO_BOOKSHELF":
            return {
                ...state,
                bookReadlist: [action.payload, ...state.bookReadlist],
            };
        case "REMOVE_BOOK_FROM_BOOKSHELF":
            return {
                ...state,
                bookReadlist: state.bookReadlist.filter(
                    (book) => book.id !== action.payload
                )
            };
        case "ADD_BOOK_TO_DONE":
            return {
                ...state,
                bookReadlist: state.bookReadlist.filter(
                    (book) => book.id !== action.payload.id
                ),
                bookRead: [action.payload, ...state.bookRead]
            };
        case "REMOVE_BOOK_FROM_DONE":
            return {
                ...state,
                bookRead: state.bookRead.filter((book) => book.id !== action.payload)
            };
        default:
            return state;
    }
}